import { AffordableVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/AffordableVideoProductionInBurDubai";
import { AnimationVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/AnimationVideoProductionInBurDubai";
import { BestVideoProductionServicesInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/BestVideoProductionServicesInBurDubai";
import { BrandStorytellingVideoServicesInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/BrandStorytellingVideoServicesInBurDubai";
import { BusinessVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/BusinessVideoProductionInBurDubai";
import { CommercialVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/CommercialVideoProductionInBurDubai";
import { CorporateVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/CorporateVideoProductionInBurDubai";
import { CreativeVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/CreativeVideoProductionInBurDubai";
import { DocumentaryVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/DocumentaryVideoProductionInBurDubai";
import { EventVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/EventVideoProductionInBurDubai";
import { GreenScreenVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/GreenScreenVideoProductionInBurDubai";
import { ProductVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/ProductVideoProductionInBurDubai";
import { ProfessionalVideographyServicesInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/ProfessionalVideographyServicesInBurDubai";
import { PromotionalVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/PromotionalVideoProductionInBurDubai";
import { RealEstateVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/RealEstateVideoProductionInBurDubai";
import { ShortFilmProductionServicesInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/ShortFilmProductionServicesInBurDubai";
import { SocialMediaVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/SocialMediaVideoProductionInBurDubai";
import { TrainingAndELearningVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/TrainingAndELearningVideoProductionInBurDubai";
import { VideoEditingServicesInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/VideoEditingServicesInBurDubai";
import { YouTubeVideoProductionInBurDubai } from "../../../Pages/AllSeoPages/VideoAdProduction/bur_dubai/YouTubeVideoProductionInBurDubai";
import { Helmet } from "react-helmet";

export const BestVideoProductionServicesInBurDubaiSEO = () => (
  <>
    <Helmet>
      {/* Page Title */}
      <title>Best Video Production Services in Bur Dubai | MilaajBrandset</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="MilaajBrandset offers the best video production services in Bur Dubai, delivering cinematic visuals and compelling storytelling to elevate your brand and engage audiences."
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="best video production services Bur Dubai, video production Bur Dubai, professional video services, corporate video production Bur Dubai"
      />

      {/* Open Graph (OG) Tags for Social Media Sharing */}
      <meta
        property="og:title"
        content="Best Video Production Services in Bur Dubai | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers the best video production services in Bur Dubai, delivering cinematic visuals and compelling storytelling to elevate your brand and engage audiences."
      />
      <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
      <meta
        property="og:url"
        content="https://milaajbrandset.com/best-video-production-services-in-bur-dubai"
      />
      <meta property="og:type" content="website" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Best Video Production Services in Bur Dubai | MilaajBrandset"
      />
      <meta
        name="twitter:description"
        content="MilaajBrandset offers the best video production services in Bur Dubai, delivering cinematic visuals and compelling storytelling to elevate your brand and engage audiences."
      />
      <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />

      {/* Schema Markup for Local SEO */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers the best video production services in Bur Dubai, delivering cinematic visuals and compelling storytelling to elevate your brand and engage audiences.",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Bur Dubai",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2598, // Approximate latitude for Bur Dubai
              "longitude": 55.2948 // Approximate longitude for Bur Dubai
            },
            
            "url": "https://milaajbrandset.com/best-video-production-services-in-bur-dubai"
          }
        `}
      </script>
    </Helmet>
    <BestVideoProductionServicesInBurDubai />
  </>
);



export const AffordableVideoProductionInBurDubaiSEO = () => (
  <>
    <Helmet>
      {/* Page Title */}
      <title>Affordable Video Production in Bur Dubai | MilaajBrandset</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="MilaajBrandset provides affordable video production services in Bur Dubai, offering high-quality visuals and storytelling at budget-friendly prices to boost your brand."
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="affordable video production Bur Dubai, budget video production Bur Dubai, cost-effective video services, cheap video production Bur Dubai"
      />

      {/* Open Graph (OG) Tags for Social Media Sharing */}
      <meta
        property="og:title"
        content="Affordable Video Production in Bur Dubai | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset provides affordable video production services in Bur Dubai, offering high-quality visuals and storytelling at budget-friendly prices to boost your brand."
      />
      <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
      <meta
        property="og:url"
        content="https://milaajbrandset.com/affordable-video-production-in-bur-dubai"
      />
      <meta property="og:type" content="website" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Affordable Video Production in Bur Dubai | MilaajBrandset"
      />
      <meta
        name="twitter:description"
        content="MilaajBrandset provides affordable video production services in Bur Dubai, offering high-quality visuals and storytelling at budget-friendly prices to boost your brand."
      />
      <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />

      {/* Schema Markup for Local SEO */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset provides affordable video production services in Bur Dubai, offering high-quality visuals and storytelling at budget-friendly prices to boost your brand.",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Bur Dubai",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2598, // Approximate latitude for Bur Dubai
              "longitude": 55.2948 // Approximate longitude for Bur Dubai
            },
           
            "url": "https://milaajbrandset.com/affordable-video-production-in-bur-dubai"
          }
        `}
      </script>
    </Helmet>
    <AffordableVideoProductionInBurDubai />
  </>
);


export const CorporateVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Corporate Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert corporate video production in Bur Dubai, creating professional videos to enhance your business image and communicate your message effectively."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="corporate video production Bur Dubai, professional video production Bur Dubai, business video services, corporate video Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Corporate Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert corporate video production in Bur Dubai, creating professional videos to enhance your business image and communicate your message effectively."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/corporate-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Corporate Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert corporate video production in Bur Dubai, creating professional videos to enhance your business image and communicate your message effectively."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert corporate video production in Bur Dubai, creating professional videos to enhance your business image and communicate your message effectively.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
              
              "url": "https://milaajbrandset.com/corporate-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <CorporateVideoProductionInBurDubai />
    </>
  );



  export const PromotionalVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Promotional Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert promotional video production in Bur Dubai, creating dynamic, engaging videos to boost your brand’s visibility and drive sales."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="promotional video production Bur Dubai, advertising video Bur Dubai, marketing video production, promotional video services Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Promotional Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert promotional video production in Bur Dubai, creating dynamic, engaging videos to boost your brand’s visibility and drive sales."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/promotional-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Promotional Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert promotional video production in Bur Dubai, creating dynamic, engaging videos to boost your brand’s visibility and drive sales."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert promotional video production in Bur Dubai, creating dynamic, engaging videos to boost your brand’s visibility and drive sales.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
           
              "url": "https://milaajbrandset.com/promotional-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <PromotionalVideoProductionInBurDubai />
    </>
  );



  export const ProfessionalVideographyServicesInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Professional Videography Services in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset provides professional videography services in Bur Dubai, offering cinematic quality and creative storytelling for brands, events, and campaigns."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="professional videography services Bur Dubai, videography Bur Dubai, cinematic video production, event videography Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Professional Videography Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset provides professional videography services in Bur Dubai, offering cinematic quality and creative storytelling for brands, events, and campaigns."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/professional-videography-services-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Professional Videography Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset provides professional videography services in Bur Dubai, offering cinematic quality and creative storytelling for brands, events, and campaigns."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset provides professional videography services in Bur Dubai, offering cinematic quality and creative storytelling for brands, events, and campaigns.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
              
              "url": "https://milaajbrandset.com/professional-videography-services-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <ProfessionalVideographyServicesInBurDubai />
    </>
  );


  export const CommercialVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Commercial Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert commercial video production in Bur Dubai, creating high-impact videos to elevate your brand and drive business growth."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="commercial video production Bur Dubai, advertising video production Bur Dubai, business video services, commercial video Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Commercial Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert commercial video production in Bur Dubai, creating high-impact videos to elevate your brand and drive business growth."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/commercial-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Commercial Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert commercial video production in Bur Dubai, creating high-impact videos to elevate your brand and drive business growth."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert commercial video production in Bur Dubai, creating high-impact videos to elevate your brand and drive business growth.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
             
              "url": "https://milaajbrandset.com/commercial-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <CommercialVideoProductionInBurDubai />
    </>
  );


  
export const BusinessVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Business Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert business video production in Bur Dubai, creating professional, engaging videos to strengthen your brand and achieve your business goals."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="business video production Bur Dubai, corporate video Bur Dubai, professional business videos, video production for businesses Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Business Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert business video production in Bur Dubai, creating professional, engaging videos to strengthen your brand and achieve your business goals."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/business-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Business Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert business video production in Bur Dubai, creating professional, engaging videos to strengthen your brand and achieve your business goals."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert business video production in Bur Dubai, creating professional, engaging videos to strengthen your brand and achieve your business goals.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
              
              "url": "https://milaajbrandset.com/business-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <BusinessVideoProductionInBurDubai />
    </>
  );



  export const SocialMediaVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Social Media Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert social media video production in Bur Dubai, creating engaging, shareable videos to boost your brand on Instagram, TikTok, and YouTube."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="social media video production Bur Dubai, Instagram video production, TikTok video Bur Dubai, YouTube video production Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Social Media Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert social media video production in Bur Dubai, creating engaging, shareable videos to boost your brand on Instagram, TikTok, and YouTube."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/social-media-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Social Media Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert social media video production in Bur Dubai, creating engaging, shareable videos to boost your brand on Instagram, TikTok, and YouTube."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert social media video production in Bur Dubai, creating engaging, shareable videos to boost your brand on Instagram, TikTok, and YouTube.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
             
              "url": "https://milaajbrandset.com/social-media-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <SocialMediaVideoProductionInBurDubai />
    </>
  );


  
export const EventVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Event Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert event video production in Bur Dubai, creating cinematic videos for weddings, corporate events, and celebrations."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="event video production Bur Dubai, wedding videography Bur Dubai, corporate event video, event videography Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Event Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert event video production in Bur Dubai, creating cinematic videos for weddings, corporate events, and celebrations."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/event-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Event Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert event video production in Bur Dubai, creating cinematic videos for weddings, corporate events, and celebrations."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert event video production in Bur Dubai, creating cinematic videos for weddings, corporate events, and celebrations.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
            
              "url": "https://milaajbrandset.com/event-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <EventVideoProductionInBurDubai />
    </>
  );



  
export const CreativeVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Creative Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert creative video production in Bur Dubai, delivering innovative, visually stunning videos for brands, campaigns, and artistic projects."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="creative video production Bur Dubai, artistic video production, cinematic video Bur Dubai, innovative videography Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Creative Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert creative video production in Bur Dubai, delivering innovative, visually stunning videos for brands, campaigns, and artistic projects."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/creative-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Creative Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert creative video production in Bur Dubai, delivering innovative, visually stunning videos for brands, campaigns, and artistic projects."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert creative video production in Bur Dubai, delivering innovative, visually stunning videos for brands, campaigns, and artistic projects.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
              
              "url": "https://milaajbrandset.com/creative-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <CreativeVideoProductionInBurDubai />
    </>
  );



  export const YouTubeVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>YouTube Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert YouTube video production in Bur Dubai, creating engaging, high-quality videos to boost your channel’s views and subscribers."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="YouTube video production Bur Dubai, YouTube content creation, professional YouTube videos Bur Dubai, video production for YouTube"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="YouTube Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert YouTube video production in Bur Dubai, creating engaging, high-quality videos to boost your channel’s views and subscribers."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/youtube-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="YouTube Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert YouTube video production in Bur Dubai, creating engaging, high-quality videos to boost your channel’s views and subscribers."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert YouTube video production in Bur Dubai, creating engaging, high-quality videos to boost your channel’s views and subscribers.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
             
              "url": "https://milaajbrandset.com/youtube-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <YouTubeVideoProductionInBurDubai />
    </>
  );



  
export const VideoEditingServicesInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Video Editing Services in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert video editing services in Bur Dubai, transforming raw footage into polished, engaging content for businesses, creators, and events."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="video editing services Bur Dubai, professional video editing, video post-production Bur Dubai, content editing services"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Video Editing Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert video editing services in Bur Dubai, transforming raw footage into polished, engaging content for businesses, creators, and events."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/video-editing-services-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Video Editing Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert video editing services in Bur Dubai, transforming raw footage into polished, engaging content for businesses, creators, and events."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert video editing services in Bur Dubai, transforming raw footage into polished, engaging content for businesses, creators, and events.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
              
              "url": "https://milaajbrandset.com/video-editing-services-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <VideoEditingServicesInBurDubai />
    </>
  );


  
export const RealEstateVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Real Estate Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert real estate video production in Bur Dubai, creating captivating videos to showcase properties and attract buyers."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="real estate video production Bur Dubai, property video production, real estate videography Bur Dubai, showcase property videos"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Real Estate Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert real estate video production in Bur Dubai, creating captivating videos to showcase properties and attract buyers."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/real-estate-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Real Estate Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert real estate video production in Bur Dubai, creating captivating videos to showcase properties and attract buyers."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert real estate video production in Bur Dubai, creating captivating videos to showcase properties and attract buyers.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
             
              "url": "https://milaajbrandset.com/real-estate-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <RealEstateVideoProductionInBurDubai />
    </>
  );



  export const AnimationVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Animation Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert animation video production in Bur Dubai, creating vibrant 2D and 3D animations for brands, campaigns, and educational content."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="animation video production Bur Dubai, 2D animation Bur Dubai, 3D animation services, animated video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Animation Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert animation video production in Bur Dubai, creating vibrant 2D and 3D animations for brands, campaigns, and educational content."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/animation-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Animation Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert animation video production in Bur Dubai, creating vibrant 2D and 3D animations for brands, campaigns, and educational content."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert animation video production in Bur Dubai, creating vibrant 2D and 3D animations for brands, campaigns, and educational content.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
              
              "url": "https://milaajbrandset.com/animation-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <AnimationVideoProductionInBurDubai />
    </>
  );



  export const ProductVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Product Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert product video production in Bur Dubai, creating compelling videos to showcase your products and drive sales."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="product video production Bur Dubai, product showcase videos, e-commerce video production, product videography Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Product Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert product video production in Bur Dubai, creating compelling videos to showcase your products and drive sales."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/product-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Product Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert product video production in Bur Dubai, creating compelling videos to showcase your products and drive sales."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert product video production in Bur Dubai, creating compelling videos to showcase your products and drive sales.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
             
              "url": "https://milaajbrandset.com/product-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <ProductVideoProductionInBurDubai />
    </>
  );



  
export const BrandStorytellingVideoServicesInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Brand Storytelling Video Services in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert brand storytelling video services in Bur Dubai, creating emotionally engaging narratives to connect your brand with audiences."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="brand storytelling video Bur Dubai, narrative video production, brand video services Bur Dubai, storytelling videography"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Brand Storytelling Video Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert brand storytelling video services in Bur Dubai, creating emotionally engaging narratives to connect your brand with audiences."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/brand-storytelling-video-services-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Brand Storytelling Video Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert brand storytelling video services in Bur Dubai, creating emotionally engaging narratives to connect your brand with audiences."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert brand storytelling video services in Bur Dubai, creating emotionally engaging narratives to connect your brand with audiences.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
             "openingHours": "Mo-Fr 09:00-18:00",   
              "url": "https://milaajbrandset.com/brand-storytelling-video-services-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <BrandStorytellingVideoServicesInBurDubai />
    </>
  );


  
export const DocumentaryVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Documentary Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert documentary video production in Bur Dubai, creating authentic, impactful films for brands, communities, and causes."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="documentary video production Bur Dubai, documentary filmmaking, storytelling video services Bur Dubai, authentic video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Documentary Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert documentary video production in Bur Dubai, creating authentic, impactful films for brands, communities, and causes."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/documentary-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Documentary Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert documentary video production in Bur Dubai, creating authentic, impactful films for brands, communities, and causes."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert documentary video production in Bur Dubai, creating authentic, impactful films for brands, communities, and causes.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
            
              "url": "https://milaajbrandset.com/documentary-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <DocumentaryVideoProductionInBurDubai />
    </>
  );




  
export const TrainingAndELearningVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Training & E-Learning Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers expert training and e-learning video production in Bur Dubai, creating engaging, interactive videos for businesses, schools, and professionals."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="training video production Bur Dubai, e-learning video services, educational video production, interactive training videos Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Training & E-Learning Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers expert training and e-learning video production in Bur Dubai, creating engaging, interactive videos for businesses, schools, and professionals."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/training-and-e-learning-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Training & E-Learning Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers expert training and e-learning video production in Bur Dubai, creating engaging, interactive videos for businesses, schools, and professionals."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers expert training and e-learning video production in Bur Dubai, creating engaging, interactive videos for businesses, schools, and professionals.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2598, // Approximate latitude for Bur Dubai
                "longitude": 55.2948 // Approximate longitude for Bur Dubai
              },
              
              "url": "https://milaajbrandset.com/training-and-e-learning-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <TrainingAndELearningVideoProductionInBurDubai />
    </>
  );



  export const ShortFilmProductionServicesInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Short Film Production Services in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset provides professional short film production services in Bur Dubai, delivering cinematic visuals and compelling stories that captivate audiences."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="short film production Bur Dubai, professional film production services, cinematic video production Bur Dubai, short film makers Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Short Film Production Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset provides professional short film production services in Bur Dubai, delivering cinematic visuals and compelling stories that captivate audiences."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/short-film-production-services-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Short Film Production Services in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset provides professional short film production services in Bur Dubai, delivering cinematic visuals and compelling stories that captivate audiences."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset provides professional short film production services in Bur Dubai, delivering cinematic visuals and compelling stories that captivate audiences.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2600,
                "longitude": 55.3000
              },
              
              "url": "https://milaajbrandset.com/short-film-production-services-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <ShortFilmProductionServicesInBurDubai />
    </>
  );


  export const GreenScreenVideoProductionInBurDubaiSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Green Screen Video Production in Bur Dubai | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional green screen video production in Bur Dubai, creating dynamic, high-quality videos with seamless effects to elevate your brand."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="green screen video production Bur Dubai, professional video production services, green screen filming Dubai, video production company Bur Dubai"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Green Screen Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional green screen video production in Bur Dubai, creating dynamic, high-quality videos with seamless effects to elevate your brand."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/green-screen-video-production-in-bur-dubai"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Green Screen Video Production in Bur Dubai | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional green screen video production in Bur Dubai, creating dynamic, high-quality videos with seamless effects to elevate your brand."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional green screen video production in Bur Dubai, creating dynamic, high-quality videos with seamless effects to elevate your brand.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bur Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2600,
                "longitude": 55.3000
              },
             
              "url": "https://milaajbrandset.com/green-screen-video-production-in-bur-dubai"
            }
          `}
        </script>
      </Helmet>
      <GreenScreenVideoProductionInBurDubai />
    </>
  );